import _ from 'lodash';
import moment from 'moment';
import { PlantItemRenewalConstants } from 'plantItemRenewal/constants/plantItemRenewalConstants';
import { InfoCode } from 'shared/constants/InfoCode';

const getPlantItemRenewallLicenceTypeCode = (licenceTypes) => {
  return licenceTypes.data.find((item) => item.description === PlantItemRenewalConstants.licenceTypeDescription).code;
};

const getInfoCodeValue = (item, infoCode) => {
  let infoValue = '';
  if (Array.isArray(item?.tangibleInfos)) {
    let infos = item.tangibleInfos.find((x) => x.infoCode == infoCode);
    if (infos) infoValue = infos.infoValue;
  }
  return infoValue;
};

const getItemType = (item) => {
  let infoCode = null;
  switch (item.tangibleType) {
    case 1:
      infoCode = InfoCode.boilerType;
      break;
    case 2:
      infoCode = InfoCode.vesselType;
      break;
    case 3:
      infoCode = InfoCode.liftType;
      break;
    case 6:
      infoCode = InfoCode.amusementDeviceType;
      break;
    case 7:
      infoCode = InfoCode.mobileCraneType;
      break;
    case 8:
      infoCode = InfoCode.towerCraneType;
      break;
    case 10:
      infoCode = InfoCode.concretePlacingBoomType;
      break;
  }

  if (!infoCode) return '';

  return getInfoCodeValue(item, infoCode).replace('(Please describe)', '');
};

const getOtherItemType = (item) => {
  let infoCode = null;
  let typeInfoCode = null;
  switch (item.tangibleType) {
    case 1:
      typeInfoCode = InfoCode.boilerType;
      infoCode = InfoCode.boilerTypeOther;
      break;
    case 2:
      typeInfoCode = InfoCode.vesselType;
      infoCode = InfoCode.vesselTypeOther;
      break;
    case 3:
      typeInfoCode = InfoCode.liftType;
      infoCode = InfoCode.liftTypeOther;
      break;
    case 6:
      typeInfoCode = InfoCode.amusementDeviceType;
      infoCode = InfoCode.amusementDeviceTypeOther;
      break;
    case 7:
      typeInfoCode = InfoCode.mobileCraneType;
      infoCode = InfoCode.mobileCraneTypeOther;
      break;
  }

  if (!infoCode) return '';

  const typeValue = getInfoCodeValue(item, typeInfoCode);
  if (!typeValue.startsWith('Other')) return null;

  return getInfoCodeValue(item, infoCode);
};

const sortItemTypeDescription = (refData) => {
  const plantItemTypesList = _.cloneDeep(refData?.plant_itemtype);
  return plantItemTypesList.sort((a, b) => {
    return a.description.localeCompare(b.description);
  });
};

const filterRenewalItemsGroupAndSort = (sortedItemTypeDescription, renewalItems, statusCode = null) => {
  const clonedItem = _.cloneDeep(renewalItems);
  const result = [];

  sortedItemTypeDescription.forEach((element) => {
    let filteredItems = clonedItem.filter((item) => item.tangibleType == element.tangibletypecode);

    if (statusCode) {
      filteredItems = filteredItems.filter((item) => item.statusCode == statusCode);
    }

    if (Array.isArray(filteredItems) && filteredItems.length > 0) {
      const sortedItems = filteredItems.sort((a, b) => {
        const inDateA = moment(a.inDate);
        const inDateB = moment(b.inDate);
        return getItemType(a).localeCompare(getItemType(b)) || inDateB.diff(inDateA);
      });
      result.push({ desc: element.description, code: element.tangibletypecode, items: sortedItems });
    }
  });

  return result;
};

const getItemTypeDescription = (typeCode, refData) => {
  const itemType = refData?.plant_itemtype.find((x) => x.tangibletypecode == typeCode);
  return itemType?.description;
};

const getItemConditionList = (item) => {
  const list = [];

  const info = getInfoCodeValue(item, InfoCode.information);
  info && list.push(info);

  if (!_.isEmpty(item.electricalCertificates) || !_.isEmpty(item.engineerCertificates)) {
    item.electricalCertificates?.specialConditions && list.push(item.electricalCertificates.specialConditions);
    item.engineerCertificates?.specialConditions && list.push(item.engineerCertificates.specialConditions);
    return list;
  }

  const electricalInspectionConditions = getInfoCodeValue(item, InfoCode.electricalInspectionConditions);
  const engineeringInspectionConditionsAmusementDevice = getInfoCodeValue(
    item,
    InfoCode.engineeringInspectionConditionsAmusementDevice,
  );
  const engineeringInspectionConditionsTowerCrane = getInfoCodeValue(
    item,
    InfoCode.engineeringInspectionConditionsTowerCrane,
  );

  electricalInspectionConditions && list.push(electricalInspectionConditions);
  engineeringInspectionConditionsAmusementDevice && list.push(engineeringInspectionConditionsAmusementDevice);
  engineeringInspectionConditionsTowerCrane && list.push(engineeringInspectionConditionsTowerCrane);

  return list;
};

const getStringDate = (dateString) => {
  if (!dateString) return null;
  let momentObj = moment(dateString);

  // The date format from Amanda is not consitent...
  if (/^\d+\/\d+\/\d+/.test(dateString)) {
    momentObj = moment(dateString, 'DD-MM-YYYY');
  }

  return momentObj.format('DD MMM YYYY');
};

const getItemsSearchedByType = (searchBy) => {
  if (searchBy === 'renewalNumber') return PlantItemRenewalConstants.renewalSearchInputType.renewalNumber;
  if (searchBy === 'itemRegistrationNumber')
    return PlantItemRenewalConstants.renewalSearchInputType.itemRegistrationNumber;

  console.error('Invalid search type: ', searchBy);
};

export {
  getPlantItemRenewallLicenceTypeCode,
  getInfoCodeValue,
  sortItemTypeDescription,
  filterRenewalItemsGroupAndSort,
  getItemTypeDescription,
  getItemType,
  getOtherItemType,
  getItemConditionList,
  getStringDate,
  getItemsSearchedByType,
};
